import { useState } from 'react';
import { ChevronsUpDown } from 'lucide-react';
import {
  PiTennisBall,
  PiBowlingBall,
  PiBasketball,
  PiBaseball,
  PiBeachBall,
  PiBeerBottle,
  PiBicycle,
  PiBinoculars,
  PiBoat,
  PiBoot,
  PiBrain,
  PiBread,
  PiBroom,
  PiCableCar,
  PiCamera,
  PiCampfire,
  PiCashRegister,
  PiChefHat,
  PiClock,
  PiClub,
  PiCoffee,
  PiCoins,
  PiCompass,
  PiCourtBasketball,
  PiCowboyHat,
  PiCricket,
  PiCrosshair,
  PiDetective,
  PiDiceFive,
  PiDna,
  PiDog,
  PiDrone,
  PiFingerprint,
  PiFirstAid,
  PiFish,
  PiFlame,
  PiFlowerTulip,
  PiFlyingSaucer,
  PiFootball,
  PiFootballHelmet,
  PiFootprints,
  PiForkKnife,
  PiGameController,
  PiGuitar,
  PiHairDryer,
  PiHandsPraying,
  PiHockey,
  PiHorse,
  PiJoystick,
  PiLaptop,
  PiLightbulbFilament,
  PiMagicWand,
  PiMetronome,
  PiMicrophone,
  PiMotorcycle,
  PiMountains,
  PiMusicNotes,
  PiNeedle,
  PiPaintBrush,
  PiPaintBrushHousehold,
  PiPaintRoller,
  PiPalette,
  PiParachute,
  PiPath,
  PiPawPrint,
  PiPen,
  PiPencilRuler,
  PiPersonSimpleHike,
  PiPersonSimpleSki,
  PiPersonSimpleSnowboard,
  PiPersonSimpleSwim,
  PiPersonSimpleTaiChi,
  PiPersonSimpleThrow,
  PiPianoKeys,
  PiPingPong,
  PiPipeWrench,
  PiPizza,
  PiPokerChip,
  PiPuzzlePiece,
  PiRacquet,
  PiRadio,
  PiRobot,
  PiRocket,
  PiSailboat,
  PiScissors,
  PiScrewdriver,
  PiSecurityCamera,
  PiShoppingBag,
  PiShovel,
  PiSneaker,
  PiSneakerMove,
  PiSnowflake,
  PiSoccerBall,
  PiSpinnerBall,
  PiSprayBottle,
  PiStar,
  PiSteeringWheel,
  PiStethoscope,
  PiStorefront,
  PiStudent,
  PiSun,
  PiSunglasses,
  PiSwimmingPool,
  PiTShirt,
  PiTaxi,
  PiTent,
  PiThermometer,
  PiTicket,
  PiTipJar,
  PiTire,
  PiToilet,
  PiToiletPaper,
  PiToolbox,
  PiTooth,
  PiTowel,
  PiTractor,
  PiTrash,
  PiTree,
  PiTreeEvergreen,
  PiTrophy,
  PiTruck,
  PiTruckTrailer,
  PiUmbrella,
  PiVan,
  PiWatch,
  PiWaves,
  PiWheelchair,
  PiWind,
  PiWine,
  PiWrench,
  PiYarn
} from 'react-icons/pi';
import { cn } from '@/utils';

import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';

// Create an object mapping icon names to their components
const iconMap = {
  tennisBall: PiTennisBall,
  bowlingBall: PiBowlingBall,
  basketball: PiBasketball,
  baseball: PiBaseball,
  beachBall: PiBeachBall,
  beerBottle: PiBeerBottle,
  bicycle: PiBicycle,
  binoculars: PiBinoculars,
  boat: PiBoat,
  boot: PiBoot,
  brain: PiBrain,
  bread: PiBread,
  broom: PiBroom,
  cableCar: PiCableCar,
  camera: PiCamera,
  campfire: PiCampfire,
  cashRegister: PiCashRegister,
  chefHat: PiChefHat,
  clock: PiClock,
  club: PiClub,
  coffee: PiCoffee,
  coins: PiCoins,
  compass: PiCompass,
  courtBasketball: PiCourtBasketball,
  cowboyHat: PiCowboyHat,
  cricket: PiCricket,
  crosshair: PiCrosshair,
  detective: PiDetective,
  diceFive: PiDiceFive,
  dna: PiDna,
  dog: PiDog,
  drone: PiDrone,
  fingerprint: PiFingerprint,
  firstAid: PiFirstAid,
  fish: PiFish,
  flame: PiFlame,
  flowerTulip: PiFlowerTulip,
  flyingSaucer: PiFlyingSaucer,
  football: PiFootball,
  footballHelmet: PiFootballHelmet,
  footprints: PiFootprints,
  forkKnife: PiForkKnife,
  gameController: PiGameController,
  guitar: PiGuitar,
  hairDryer: PiHairDryer,
  handsPraying: PiHandsPraying,
  hockey: PiHockey,
  horse: PiHorse,
  joystick: PiJoystick,
  laptop: PiLaptop,
  lightbulbFilament: PiLightbulbFilament,
  magicWand: PiMagicWand,
  metronome: PiMetronome,
  microphone: PiMicrophone,
  motorcycle: PiMotorcycle,
  mountains: PiMountains,
  musicNotes: PiMusicNotes,
  needle: PiNeedle,
  paintBrush: PiPaintBrush,
  paintBrushHousehold: PiPaintBrushHousehold,
  paintRoller: PiPaintRoller,
  palette: PiPalette,
  parachute: PiParachute,
  path: PiPath,
  pawPrint: PiPawPrint,
  pen: PiPen,
  pencilRuler: PiPencilRuler,
  personSimpleHike: PiPersonSimpleHike,
  personSimpleSki: PiPersonSimpleSki,
  personSimpleSnowboard: PiPersonSimpleSnowboard,
  personSimpleSwim: PiPersonSimpleSwim,
  personSimpleTaiChi: PiPersonSimpleTaiChi,
  personSimpleThrow: PiPersonSimpleThrow,
  pianoKeys: PiPianoKeys,
  pingPong: PiPingPong,
  pipeWrench: PiPipeWrench,
  pizza: PiPizza,
  pokerChip: PiPokerChip,
  puzzlePiece: PiPuzzlePiece,
  racquet: PiRacquet,
  radio: PiRadio,
  robot: PiRobot,
  rocket: PiRocket,
  sailboat: PiSailboat,
  scissors: PiScissors,
  screwdriver: PiScrewdriver,
  securityCamera: PiSecurityCamera,
  shoppingBag: PiShoppingBag,
  shovel: PiShovel,
  sneaker: PiSneaker,
  sneakerMove: PiSneakerMove,
  snowflake: PiSnowflake,
  soccerBall: PiSoccerBall,
  spinnerBall: PiSpinnerBall,
  sprayBottle: PiSprayBottle,
  star: PiStar,
  steeringWheel: PiSteeringWheel,
  stethoscope: PiStethoscope,
  storefront: PiStorefront,
  student: PiStudent,
  sun: PiSun,
  sunglasses: PiSunglasses,
  swimmingPool: PiSwimmingPool,
  tShirt: PiTShirt,
  taxi: PiTaxi,
  tent: PiTent,
  thermometer: PiThermometer,
  ticket: PiTicket,
  tipJar: PiTipJar,
  tire: PiTire,
  toilet: PiToilet,
  toiletPaper: PiToiletPaper,
  toolbox: PiToolbox,
  tooth: PiTooth,
  towel: PiTowel,
  tractor: PiTractor,
  trash: PiTrash,
  tree: PiTree,
  treeEvergreen: PiTreeEvergreen,
  trophy: PiTrophy,
  truck: PiTruck,
  truckTrailer: PiTruckTrailer,
  umbrella: PiUmbrella,
  van: PiVan,
  watch: PiWatch,
  waves: PiWaves,
  wheelchair: PiWheelchair,
  wind: PiWind,
  wine: PiWine,
  wrench: PiWrench,
  yarn: PiYarn
};

// Export array of all icon names for selection
export const iconNames = Object.keys(iconMap);

const Icon = ({ name, size = 32, className = '', ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    // eslint-disable-next-line no-console
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return <IconComponent size={size} className={className} {...props} />;
};

const SelectIcon = ({ value, onChange, disabled }) => {
  const [isIconOpen, setIsIconOpen] = useState(false);

  const handleIconChange = (name) => {
    onChange(name);
    setIsIconOpen(false);
  };

  return (
    <Popover open={isIconOpen} onOpenChange={setIsIconOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className={cn(
            'w-full justify-between',
            !value && 'text-muted-foreground'
          )}
          disabled={disabled}
        >
          <div className="truncate">
            {value ? <Icon name={value} /> : 'Select Icon'}
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[500px] p-0">
        <ScrollArea className="h-[300px] p-4">
          <div className="grid grid-cols-12">
            {Object.entries(iconMap).map(([name]) => (
              <div
                key={name}
                className="p-1 m-1 cursor-pointer"
                onClick={() => handleIconChange(name)}
              >
                <Icon name={name} size={32} />
              </div>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};

export { Icon, SelectIcon };
